import { Button, useTheme } from '@mui/material';
import * as React from 'react';

interface IProps {
  onClick: () => void;
}

export const ClearFiltersButton: React.FC<IProps> = ({ onClick }) => {
  const { typography } = useTheme();

  return (
    <Button
      onClick={onClick}
      sx={{
        fontSize: 16,
        fontWeight: typography.fontWeightRegular,
        paddingY: 0,
        height: 32,
      }}
      data-action="clear_filters_button"
    >
      Clear filters
    </Button>
  );
};
